import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const links = [
  { href: "#services", label: "Services" },
  { href: "#pricing", label: "Pricing" },
  { href: "#about", label: "About" },
  { href: "#contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-50 bg-[#EAF4DD]/95 backdrop-blur-xl border-b border-[#2A3430]/10 text-[#2A3430]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Logo variant="dark" />

          <ul className="hidden md:flex items-center gap-8">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`nav-link-${l.label.toLowerCase()}`}
                  className="text-sm text-[#2A3430]/80 hover:text-[#2A3430] transition-colors duration-200 relative after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#C57A5A] hover:after:w-full after:transition-all"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="hidden md:block">
            <a
              href="#contact"
              data-testid="nav-cta-quote"
              className="inline-flex items-center justify-center bg-[#C57A5A] hover:bg-[#A96444] text-white text-sm font-medium px-5 py-2.5 rounded-full transition-all duration-300 shadow-sm hover:shadow-lg hover:shadow-[#C57A5A]/25"
            >
              Get a free quote
            </a>
          </div>

          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-full hover:bg-[#2A3430]/10 transition"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>

        {open && (
          <div className="md:hidden pb-4 border-t border-[#2A3430]/10 pt-3">
            <ul className="flex flex-col gap-1">
              {links.map((l) => (
                <li key={l.href}>
                  <a
                    onClick={() => setOpen(false)}
                    href={l.href}
                    data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                    className="block px-2 py-2.5 rounded-lg text-sm text-[#2A3430]/90 hover:bg-[#2A3430]/5"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li className="pt-2">
                <a
                  href="#contact"
                  onClick={() => setOpen(false)}
                  data-testid="nav-mobile-cta-quote"
                  className="block text-center bg-[#C57A5A] hover:bg-[#A96444] text-white text-sm font-medium px-5 py-3 rounded-full"
                >
                  Get a free quote
                </a>
              </li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
